import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
import { RightsWrapper } from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class LeadStatus extends Component {
    state = {
        id: '',
        total: 0,
        activeTab: '0',
        refreshChild: false
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            this.setState({ exportParams: params })
            let data = await Request.getLeadStatusDetails({
                ...params,
                regExFilters: []
            })
            this.setState({ total: data.total })
            resolve(data)
        })
    }
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                let x = null
                if (this.state.id) {
                    values._id = this.state.id
                    x = await Request.updateLeadStatusDetails(values)
                } else {
                    x = await Request.addLeadStatusDetails(values)
                }

                if (!x.error) {
                    this.setState({
                        id: '',
                        activeTab: '0',
                    })
                    notification.success({
                        message: this.state.id
                            ? `Lead Status Updated Successfully`
                            : 'Lead Status Added successfully'
                    })
                    if (!this.state.id) {
                        form.resetFields()
                    }
                    if (this.table && this.table.current)
                        this.table.current.reload()

                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    deleteLeadStatusDetails = async data => {
        this.setState({ loading: true })
        await Request.deleteLeadStatusDetails(data)

        this.setState({ loading: false })

        this.table.current.reload()

        notification.success({
            message: 'Deleted Successfully',
            duration: 20,
            key: `${data._id}-close`
        })
    }
    callback = (value) => {
        if (value) {
            this.chooseTab(value)
        }
    }
    setLeadStatusDetailsData(companyDetailId) {
        if (companyDetailId) {
            Request.leadStatusDetailsByID({ id: companyDetailId }).then(
                ({ doc, error, message }) => {
                    if (!error && doc) {
                        this.setState({
                            id: doc._id,
                            activeTab: '1'
                        })

                        this.props.form.setFieldsValue({
                            statusName: doc.statusName,
                            desk: doc.desk
                        })
                    } else {
                        notification.error({
                            message: 'Error Getting Data',
                            description: message
                        })
                    }
                }
            )
        }
    }
    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    componentWillMount() {

    }

    async componentDidMount() {
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }
    chooseTab(value) {
        this.setState({
            activeTab: value
        })
    }
    render() {
        const { dispatch } = this.props
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props
        const { id } = this.state;

        const inputTypes = {
            fields: [
                {
                    label: 'Status Name',
                    key: 'statusName',
                    required: true
                },
                {
                    label: 'Desk',
                    key: 'desk',
                    type: 'select',
                    mode: 'multiple',
                    showSearch: true,
                    options: [
                        { _id: 'Operation Manager Desk', name: 'Operation Manager Desk' },
                        { _id: 'Front Desk', name: 'Counselling Desk' },
                        { _id: 'Registration Desk', name: 'Registration Desk' },
                        { _id: 'Application Desk', name: 'Application Desk' },
                        { _id: 'Visa Desk', name: 'Visa Desk' },
                        { _id: 'Claim Desk', name: 'Claim Desk' },
                        { _id: 'Archive Desk', name: 'Archive Desk' },
                    ],
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.name,
                    required: true,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ desk: v });
                    },
                }
            ]
        };

        const columns = [
            {
                title: 'Status Name',
                key: 'statusName',
            },
            {
                title: 'Desk',
                key: 'desk',
                render: (text, record) => {
                    return (
                        <div>
                            {record.desk && Array.isArray(record.desk) ? record.desk.join(', ') : record.desk}
                        </div>
                    )
                }
            },
            {
                title: 'Updated By',
                key: 'lastUpdatedByName',
                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
                            <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    record.businessId ?
                        <React.Fragment>
                            <RightsWrapper myRight={'leadStatus.edit'}>
                                <Tooltip title="Edit Lead Status">
                                    <Button
                                        className={styles.btn}
                                        shape="circle"
                                        onClick={() => {
                                            this.setLeadStatusDetailsData(record._id)
                                        }}
                                        icon="edit"
                                    />
                                </Tooltip>
                            </RightsWrapper>
                            <RightsWrapper myRight={'leadStatus.delete'}>
                                <Tooltip title="Delete Lead Status">
                                    <Popconfirm
                                        title="Are you sure delete this Lead Status?"
                                        onConfirm={() => {
                                            this.deleteLeadStatusDetails({ _id: record._id })
                                        }}
                                        okText="Yes"
                                        cancelText="No">
                                        <Button
                                            className={styles.btn}
                                            shape="circle"
                                            icon="delete"
                                        />
                                    </Popconfirm>
                                </Tooltip>
                            </RightsWrapper>
                        </React.Fragment>
                        : null
                )
            }
        ]
        return (
            <PageHeaderWrapper title={` Lead Status Details `}>
                <Card bordered={true}>
                    <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                        <TabPane tab={`All Lead Status`} key={0}>
                            <h2>{`Total : ${this.state.total}`}</h2>
                            <TableComp
                                ref={this.table}
                                columns={columns}
                                apiRequest={this.apiRequest}
                                extraProps={{ scroll: { x: 900 } }}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 50,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>

                        <TabPane tab={(id ? 'Edit' : 'Add') + ' Lead Status'} key={1}>
                            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                                <GetAllFormFields
                                    inputSchema={inputTypes}
                                    refresh={this.refreshFxn}
                                    getFieldDecorator={getFieldDecorator}
                                />
                                <Button
                                    type=""
                                    htmlType="submit"
                                    style={{
                                        marginBottom: 10,
                                        marginLeft: '33%',
                                        backgroundColor: 'green',
                                        color: 'white'
                                    }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                                <Button
                                    type="primary"
                                    style={{ marginBottom: 10, marginLeft: '1%' }}
                                    loading={this.props.loading}
                                    onClick={() => {
                                        this.props.form.resetFields()
                                    }}>
                                    RESET
                                </Button>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        );
    }
}

export default LeadStatus